import React from 'react';

function AddBookmark({ clicked }) {
    return (
        <button
            onClick={clicked}
            className="group bg-blue-50 hover:bg-blue-100 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 p-6 h-48 flex flex-col items-center justify-center border-2 border-dashed border-blue-200 hover:border-blue-400 hover:scale-105"
        >
            <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform shadow-lg">
                <span className="text-white text-4xl font-light">+</span>
            </div>
            <span className="text-gray-700 font-semibold group-hover:text-gray-900 transition-colors">
                Add Bookmark
            </span>
        </button>
    );
}

export default AddBookmark;
